import React from 'react';

import { coreTranslations, sharedTranslations } from 'translations';
import featureService from '@services/feature.service';
import { TextKeywordImage, TopicsImage, WeatherEventsImage } from '../../../Images/index'
import PermissionService from '@services/permission.service';


const { permissions } = new PermissionService();

export const tilesConfig = [
    {
        title: sharedTranslations.ng_shared_weatherAndEvents,
        description: coreTranslations.ng_core_weatherAndEventsDescription,
        path: '/weather-and-events',
        visible: access => access.canViewWeatherAndEvents(),
        icon: <WeatherEventsImage color="primary" />
    },
    {
        title: sharedTranslations.ng_shared_topics,
        description: coreTranslations.ng_core_topicsDescription,
        path: '/topics',
        visible: access => access.canViewTopics(),
        icon: <TopicsImage color="primary" className="onsolve-subscription__icon" />
    },
    {
        title: coreTranslations.ng_core_textToKeyword,
        description: coreTranslations.ng_core_textToKeywordDescription,
        path: '/text-to-keyword',
        icon: <TextKeywordImage color="primary" className="onsolve-subscription__icon" />,
        visible: access =>
            permissions.canManageTtKeyword() && access.canOrganizationAdmin() && featureService.getFeature('textToKeywords')
    }
];
